import { FeedTag } from "@pages/Keyword/utils/types";

import { EXPLORE_MORE } from "./constants";

export const getExploreMoreObjectByTags = (tags: FeedTag[]) => {
  const exploreMoreObj = EXPLORE_MORE.filter((data) =>
    data.tags?.some((objectTag) =>
      tags.some((tag) => tag.urlPath === objectTag.urlPath)
    )
  );

  return exploreMoreObj;
};
